"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  name: 'Nama',
  tel: 'Telefon',
  save: 'Jimat',
  confirm: 'Mengesahkan',
  cancel: 'Batal',
  delete: 'Padam',
  complete: 'Selesai',
  loading: 'Memuatkan...',
  telEmpty: 'Sila isikan nombor telefon',
  nameEmpty: 'Sila isikan nama anda',
  nameInvalid: 'Sila masukkan nama yang betul',
  confirmDelete: 'Anda pasti mahu memadamkannya',
  telInvalid: 'Sila masukkan nombor telefon yang sah',
  vanCalendar: {
    end: 'Tamat',
    start: 'Mulakan',
    title: 'Pemilihan Tarikh',
    confirm: 'Pasti',
    startEnd: 'Mulakan/Tamat',
    weekdays: ['Hari', 'Satu', 'Dua', 'Tiga', 'Empat', 'Lima', 'Enam'],
    monthTitle: function monthTitle(year, month) {
      return "Bulan " + month + " Tahun "+year;
    },
    rangePrompt: function rangePrompt(maxRange) {
      return "Bilangan hari yang dipilih tidak boleh melebihi " + maxRange + " langit";
    }
  },
  vanContactCard: {
    addText: '添加联系人'
  },
  vanContactList: {
    addText: '新建联系人'
  },
  vanPagination: {
    prev: '上一页',
    next: '下一页'
  },
  vanPullRefresh: {
    pulling: 'Tarik ke bawah untuk menyegarkan...',
    loosing: 'Lepaskan untuk menyegarkan...'
  },
  vanSubmitBar: {
    label: '合计：'
  },
  vanCoupon: {
    unlimited: '无使用门槛',
    discount: function discount(_discount) {
      return _discount + "折";
    },
    condition: function condition(_condition) {
      return "满" + _condition + "元可用";
    }
  },
  vanCouponCell: {
    title: '优惠券',
    tips: '暂无可用',
    count: function count(_count) {
      return _count + "张可用";
    }
  },
  vanCouponList: {
    empty: '暂无优惠券',
    exchange: '兑换',
    close: '不使用优惠券',
    enable: '可用',
    disabled: '不可用',
    placeholder: '请输入优惠码'
  },
  vanAddressEdit: {
    area: '地区',
    postal: '邮政编码',
    areaEmpty: '请选择地区',
    addressEmpty: '请填写详细地址',
    postalEmpty: '邮政编码格式不正确',
    defaultAddress: '设为默认收货地址',
    telPlaceholder: '收货人手机号',
    namePlaceholder: '收货人姓名',
    areaPlaceholder: '选择省 / 市 / 区'
  },
  vanAddressEditDetail: {
    label: '详细地址',
    placeholder: '街道门牌、楼层房间号等信息'
  },
  vanAddressList: {
    add: '新增地址'
  }
};
exports.default = _default;